var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data"},[_c('img',{staticClass:"no-data-image",attrs:{"src":require("../static/pic/nodata.png"),"alt":"No Data"}}),_c('p',{staticClass:"no-data-text"},[_vm._v("暂无数据")])])
}]

export { render, staticRenderFns }